/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { selectRequestStatus } from '../../reducers/deploymentsSlice';
import { PageCenteredLayout } from '../layout/PageCenteredLayout';
import LoadingIndicator from '../common/LoadingIndicator';
import { useAppDispatch } from '../../hooks';
import { useToken } from '../../hooks/useToken';
import {
  fetchSolutionDeployments,
  selectSolutionDeployments,
  selectSolutionDeploymentsStatus,
} from '../../reducers/solutionDeploymentsSlice';
import { fetchSnowflakeAccounts, selectAccounts } from '../../reducers/snowflakeAccountsSlice';
import { useSelector } from 'react-redux';
import SolutionDemosList from '../project/SolutionDemosList';

import DeploymentsBySolutionList from '../project/DeploymentsBySolutionList';

// Custom hook to detect if screen is below the lg breakpoint (1024px)
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024); // 1024px is the lg breakpoint in Tailwind
    };

    // Check on initial render
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return isMobile;
};

export default function DeploymentsPage() {
  const isMobile = useIsMobile();
  const dispatch = useAppDispatch();
  const token = useToken();
  const solutonDeployments = useSelector(selectSolutionDeployments);
  const solutionDeploymentsStatus = useSelector(selectSolutionDeploymentsStatus);
  const snowflakeAccounts = useSelector(selectAccounts);

  useEffect(() => {
    if (token) {
      dispatch(fetchSolutionDeployments(token)).catch((err) => {
        console.error('Failed to fetch solution solutonDeployments:', err);
      });
      dispatch(fetchSnowflakeAccounts(token)).catch((err) => {
        console.error('Failed to fetch snowflake accounts:', err);
      });
    }
  }, [token, dispatch]);

  const getAccountName = (accountId: number) => {
    const account = snowflakeAccounts.find((acc) => acc.id === accountId);
    return account?.account ?? `Account ID: ${accountId}`;
  };

  return (
    <PageCenteredLayout>
      {/* Only show the title when on mobile (sidebar is hidden) */}
      {isMobile && <h1 className="mb-12 text-3xl text-dataops-primary-dark-blue/40">Deployments</h1>}
      <LoadingIndicator selectRequestStatus={selectRequestStatus} />

      {/* Deployments Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-dataops-primary-dark-blue mb-4">Deployments</h2>
        <LoadingIndicator selectRequestStatus={() => solutionDeploymentsStatus} />
        <SolutionDemosList solutonDeployments={solutonDeployments} getAccountName={getAccountName} />
      </div>

      {/* Legacy Deployments Section */}
      <div>
        <h2 className="text-2xl font-semibold text-dataops-primary-dark-blue mb-4">Legacy Deployments</h2>
        <DeploymentsBySolutionList />
      </div>
    </PageCenteredLayout>
  );
}
